import { render, staticRenderFns } from "./FormTagsCustom.vue?vue&type=template&id=7dad38e1"
import script from "./FormTagsCustom.vue?vue&type=script&lang=js"
export * from "./FormTagsCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports